const ANONYMOUS = 'ANONYMOUS';
const DIRECT_TO_PAY = 'DIRECT_TO_PAY';
const ALREADY_PREMIUM = 'ALREADY_PREMIUM';
const FREE_TRIAL_ELIGIBLE = 'FREE_TRIAL_ELIGIBLE';

export { ANONYMOUS, DIRECT_TO_PAY, ALREADY_PREMIUM, FREE_TRIAL_ELIGIBLE };
